export enum APIStatusEnum {
  ERROR = 'error',
  WAIT = 'wait',
  READY = 'ready',
  NORESULTS = 'noresults',
  OVERFILTERED = 'overfiltered',
  RESYNC = 'resync',
}
